import {updateToolCall} from "../../../../contextManagement/toolCallUpdater.ts";
import {executeToolCall} from "./toolCallExecutor.ts";

export const finishToolCall = (llmRequestRefs: any, settingsObjRef: any, userObjRef: any, environmentObjRef: any, message: any, setMessages: any, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, updateElementInProgress: any, websocketRef: any, dynamicStateObjRef: any) => {
    try {
        const parsedArgs = message.args.trim() === '' ? {} : JSON.parse(message.args);
        updateToolCall(llmRequestRefs, message.id, {args: parsedArgs});

        llmRequestRefs.current.lastToolUsed = message.name;
        executeToolCall({id: message.id, name: message.name, args: parsedArgs}, setMessages, messagesRef, currentMessageRef, messagesSequenceRef, updateElementInProgress, settingsObjRef, userObjRef, environmentObjRef, dynamicStateObjRef, llmRequestRefs, websocketRef);
    } catch (error) {
        console.error('Error in toolCallRequestFinish:', error);
    }
};
